import { Custom } from '@clearkit/icons';

import { useEntitlements } from '~/hooks/account';
import useOnboardingStatus from '~/hooks/account/useOnboardingStatus';

import { HomeHeading } from '../HomeHeading';
import { StepDataMapping, StepSetupForms } from '../HomeNextSteps';

export const HomeSidebarNextSteps = () => {
  const {
    hasEnrichmentFieldMappings,
    hasFormConnectors,
    loading,
  } = useOnboardingStatus();
  const { hasAccessEnrichment } = useEntitlements();

  const noAccess = !hasAccessEnrichment;
  const showEnrichmentStep = !hasEnrichmentFieldMappings && hasAccessEnrichment;
  const showFormsStep = !hasFormConnectors;
  const isSectionComplete = !showEnrichmentStep && !showFormsStep;

  if (noAccess || isSectionComplete || loading) return null;

  return (
    <section className="pt-8 space-y-8">
      <HomeHeading>
        <Custom height={16} width={16} /> Next steps with Clearbit
      </HomeHeading>
      {showEnrichmentStep ? <StepDataMapping /> : null}
      {showFormsStep ? <StepSetupForms /> : null}
    </section>
  );
};
